import styled from 'styled-components';

export const CollaborationWrapper = styled.div`
  .publish_wrp {
    & .scroll-container .scrollable-div {
      padding: 0;
    }
    & .big-heading {
      margin: 12px 0;
      font-style: normal;
      font-weight: 500;
      font-size: 20px;
      line-height: 24px;
      color: #000000;
    }
    & .sub-heading {
      margin: 12px 0;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      color: #404f67;
    }

    & .success-popup {
      display: flex;
      justify-content: center;
      text-align: center;
    }

    & .success-popup > div > p {
      font-size: 16px;
    }

    & .attached-doc-text {
      font-size: 14px;
      color: #219fff;
    }

    & .table-heading {
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      color: #404f67;
      .table-element {
        font-size: 14px;
        border-radius: 6px;
        padding: 16px;
        text-align: center;
        background: #219fff33;
        color: #219fff;
      }
    }

    & .accept-checkbox {
      justify-content: start;
    }

    & .accept-checkbox-mobile {
      justify-content: start;
      flex-direction: column;
    }

    & .text-content {
      margin: 12px 0;
      font-size: 16px;
      font-family: Poppins;
    }

    & .section {
      margin-bottom: 24px;
    }

    & .doc-container-main {
      margin: 32px 0;
    }

    & .doc-container-main-nq {
      margin: 12px 0;
    }

    & .tc-container-main {
      margin: 32px 0;
    }

    & .tc-container {
      margin: 12px 0;
      display: flex;
    }

    & .sub-heading-tc {
      margin-left: 12px;
      font-size: 14px;
    }

    & .sub-heading-document {
      color: #404f67;
      margin-left: 12px;
      font-size: 14px;
    }

    & .radio-group {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }

    & .radio-group-label {
      margin: 12px 0;
    }

    & .document-container {
      margin-top: 12px;
      display: flex;
      justify-content: space-between;
    }

    & .document-container-mobile {
      margin-top: 12px;
      display: flex;
      flex-direction: column;
    }

    & .document-container-buttons {
      display: flex;
      & .download-link {
        text-decoration: none;
        & .download-btn {
          font-size: 14px;
        }
      }
      & .upload-btn {
        font-size: 14px;
      }
    }

    & .document-list {
      margin: 12px 0;
    }

    & .accept-terms {
      margin: 40px 0;
    }

    & .accept-checkbox-text {
      margin-left: 12px;
      margin-top: 12px;
    }
    & .radio-btn-label {
      margin-top: 20px;
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;
      color: #404f67;
    }
    & .mandatory-field {
      text-align: right;
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;
      color: #7e8f9a;
      margin-bottom: 20px;
      text-decoration: underline;
    }

    & .popup-button {
      margin: 32px auto;
      align-items: center;
      width: 150px;
    }

    & .loading-bar {
      margin-top: 15%;
    }
  }
`;
